export default (productsCode, data) => {
  if (productsCode.length === 1) return true;
  return productsCode.every(product => data[product] === data[productsCode[0]]);
};
